import React from 'react';
import { SocialMediaPost } from './components/SocialMediaPost';
export function App() {
  return <div className="min-h-screen bg-[#0f0f1b] flex items-center justify-center p-4 md:p-8" data-id="element-0">
      {/* Wrapper to demonstrate the component in a realistic viewing environment */}
      <div className="w-full max-w-[600px] flex flex-col items-center gap-8" data-id="element-1">
        <SocialMediaPost data-id="element-2" />

        <p className="text-white/40 text-sm font-medium text-center" data-id="element-3">
          1:1 Square Format • Optimized for Instagram / LinkedIn
        </p>
      </div>
    </div>;
}